import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ConfigProvider, theme } from 'antd';  // ← 添加
import { ThemeProvider, useTheme } from './context/ThemeContext';  // ← 修改
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import DrawingListPage from './pages/DrawingListPage';
import DrawingFormPage from './pages/DrawingFormPage';
import DrawingDetailPage from './pages/DrawingDetailPage';
import DeleteRequestsPage from './pages/DeleteRequestsPage';
import SystemLogPage from './pages/SystemLogPage';
import RecycleBinPage from './pages/RecycleBinPage';
import DrawingApprovalsPage from './pages/DrawingApprovalsPage';
import ProtectedRoute from './components/ProtectedRoute';

// 包装组件，用于获取 theme 状态并传给 ConfigProvider
const ThemedApp = () => {
  const { isDarkMode } = useTheme();
  
  return (
    <ConfigProvider
      theme={{
        algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
      }}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
          <Route path="/drawings/:deviceType" element={<ProtectedRoute><DrawingListPage /></ProtectedRoute>} />
          <Route path="/drawings/:deviceType/new" element={<ProtectedRoute><DrawingFormPage /></ProtectedRoute>} />
          <Route path="/drawings/:deviceType/edit/:id" element={<ProtectedRoute><DrawingFormPage /></ProtectedRoute>} />
          <Route path="/drawings/:deviceType/detail/:id" element={<ProtectedRoute><DrawingDetailPage /></ProtectedRoute>} />
          <Route path="/delete-requests" element={<ProtectedRoute requireLeader><DeleteRequestsPage /></ProtectedRoute>} />
          <Route path="/drawing-approvals" element={<ProtectedRoute requireLeader><DrawingApprovalsPage /></ProtectedRoute>} />
          <Route path="/recycle-bin" element={<ProtectedRoute requireAdmin><RecycleBinPage /></ProtectedRoute>} />
          <Route path="/system-logs" element={<ProtectedRoute requireAdmin><SystemLogPage /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
};

function App() {
  return (
    <ThemeProvider>
      <ThemedApp />
    </ThemeProvider>
  );
}

export default App;